import { Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { DangerIcon } from "../svgIcon/DangerIcon";

const AVCTableError = ({ message }) => {
  const theme = useTheme();
  return (
    <Stack justifyContent="center" alignItems="center" height="100%" width="100%" spacing={2}>
      <DangerIcon color={theme.palette.error.main} fontSize="large" />
      <Typography variant="subtitle1" color="error.main">
        {message}
      </Typography>
    </Stack>
  );
};

export default AVCTableError;
